import React from "react";
import PropTypes from "prop-types";
import AppBar from "@material-ui/core/AppBar";
import CssBaseline from "@material-ui/core/CssBaseline";
import Divider from "@material-ui/core/Divider";
import Drawer from "@material-ui/core/Drawer";
import Hidden from "@material-ui/core/Hidden";
import IconButton from "@material-ui/core/IconButton";
// import InboxIcon from "@material-ui/icons/MoveToInbox";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import EventAvailableIcon from "@material-ui/icons/EventAvailable";
import DescriptionIcon from "@material-ui/icons/Description";

import ListItemText from "@material-ui/core/ListItemText";
import VpnKeyIcon from "@material-ui/icons/VpnKey";
import MonetizationOnIcon from "@material-ui/icons/MonetizationOn";
// import MailIcon from "@material-ui/icons/Mail";
import MenuIcon from "@material-ui/icons/Menu";
import Toolbar from "@material-ui/core/Toolbar";
import Typography from "@material-ui/core/Typography";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import ReceiptIcon from "@material-ui/icons/Receipt";
import AssessmentIcon from "@material-ui/icons/Assessment";
import BackupIcon from "@material-ui/icons/Backup";
import { Link } from "react-router-dom";

import Conf from "../Conf";

const drawerWidth = 250;

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
  },
  drawer: {
    [theme.breakpoints.up("sm")]: {
      width: drawerWidth,
      flexShrink: 0,
    },
  },
  appBar: {
    [theme.breakpoints.up("sm")]: {
      width: `calc(100% - ${drawerWidth}px)`,
      marginLeft: drawerWidth,
    },
  },
  menuButton: {
    marginRight: theme.spacing(2),
    [theme.breakpoints.up("sm")]: {
      display: "none",
    },
  },
  // necessary for content to be below app bar
  toolbar: theme.mixins.toolbar,
  drawerPaper: {
    width: drawerWidth,
  },
  content: {
    flexGrow: 1,
    padding: theme.spacing(3),
  },
}));
function goCreate() {
  window.location = Conf.frontendURL + "create";
}
function goReport() {
  window.location = Conf.frontendURL + "report";
}
function goRepository() {
  window.location = Conf.frontendURL + "repository";
}
function goSignOut() {
  localStorage.removeItem(Conf.cookieName);
  window.location = Conf.frontendURL + "login";
}

function Navbar(props) {
  const { window } = props;
  const classes = useStyles();
  const theme = useTheme();
  const [mobileOpen, setMobileOpen] = React.useState(false);

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };
  const drawer = (
    <div>
      <div className={classes.toolbar} />
      <Divider />
      <List>
        <ListItem button onClick={() => goCreate()}>
          <ListItemIcon style={{ minWidth: "40px" }}>
            <ReceiptIcon />
          </ListItemIcon>
          <ListItemText>ออกใบเสร็จ</ListItemText>
        </ListItem>
        <ListItem button onClick={() => goReport()}>
          <ListItemIcon style={{ minWidth: "40px" }}>
            <AssessmentIcon />
          </ListItemIcon>
          <ListItemText>รายงานใบแจ้งหนี้</ListItemText>
        </ListItem>
        <ListItem
          button
          component={Link}
          to={`${process.env.PUBLIC_URL}/report/bill`}
        >
          <ListItemIcon style={{ minWidth: "40px" }}>
            <DescriptionIcon />
          </ListItemIcon>
          <ListItemText>รายงานใบเสร็จ</ListItemText>
        </ListItem>
        <ListItem
          button
          component={Link}
          to={`${process.env.PUBLIC_URL}/delivery`}
        >
          <ListItemIcon style={{ minWidth: "40px" }}>
            <EventAvailableIcon />
          </ListItemIcon>
          <ListItemText>หลักฐานการส่งเงิน</ListItemText>
        </ListItem>
        <ListItem button onClick={() => goRepository()}>
          <ListItemIcon style={{ minWidth: "40px" }}>
            <BackupIcon />
          </ListItemIcon>
          <ListItemText>คลังใบเสร็จ</ListItemText>
        </ListItem>
        <ListItem
          button
          component={Link}
          to={`${process.env.PUBLIC_URL}/receipt`}
        >
          <ListItemIcon style={{ minWidth: "40px" }}>
            <MonetizationOnIcon />
          </ListItemIcon>
          <ListItemText>รายงานการใช้ใบเสร็จ</ListItemText>
        </ListItem>
        <ListItem button onClick={() => goSignOut()}>
          <ListItemIcon style={{ minWidth: "40px" }}>
            <VpnKeyIcon />
          </ListItemIcon>
          <ListItemText>ลงชื่อออก</ListItemText>
        </ListItem>
      </List>
      <Divider />
    </div>
  );

  const container =
    window !== undefined ? () => window().document.body : undefined;

  return (
    <div className={classes.root}>
      <CssBaseline />
      <AppBar position="fixed" className={classes.appBar}>
        <Toolbar>
          <IconButton
            color="inherit"
            aria-label="open drawer"
            edge="start"
            onClick={handleDrawerToggle}
            className={classes.menuButton}
          >
            <MenuIcon />
          </IconButton>
          <Typography variant="h6" style={{ fontWeight: "400" }} noWrap>
            CMUL Digital Payment
          </Typography>
        </Toolbar>
      </AppBar>
      <nav className={classes.drawer} aria-label="mailbox folders">
        {/* The implementation can be swapped with js to avoid SEO duplication of links. */}
        <Hidden smUp implementation="css">
          <Drawer
            container={container}
            variant="temporary"
            anchor={theme.direction === "rtl" ? "right" : "left"}
            open={mobileOpen}
            onClose={handleDrawerToggle}
            classes={{
              paper: classes.drawerPaper,
            }}
            ModalProps={{
              keepMounted: true, // Better open performance on mobile.
            }}
          >
            {drawer}
          </Drawer>
        </Hidden>
        <Hidden xsDown implementation="css">
          <Drawer
            classes={{
              paper: classes.drawerPaper,
            }}
            variant="permanent"
            open
          >
            {drawer}
          </Drawer>
        </Hidden>
      </nav>
    </div>
  );
}

Navbar.propTypes = {
  window: PropTypes.func,
};

export default Navbar;
